import get from 'lodash/get';

const medicationCheckMixins = {
  computed: {
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(
        error => error.metadata && error.metadata.checkKey === this.ikey,
      );
      return errors;
    },
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      const warnings = get(
        this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(
        warning => warning.metadata && warning.metadata.checkKey === this.ikey,
      );
      return warnings;
    },
    medDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'medDisabled');
    },
    routeDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'routeDisabled');
    },
    unitDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'unitDisabled');
    },
    dosageUnitError() {
      return this.errors.find(error => error.metadata.errorId === 'dosageUnit');
    },
    locationMedErrors() {
      return this.errors.filter(error => error.metadata.errorId === 'locationMed');
    },
    locationFluidErrors() {
      return this.errors.filter(error => error.metadata.errorId === 'locationFluid');
    },
  }
};

export default medicationCheckMixins;